export abstract class ApiService {
    options: {
        apiUrl: string;
        historyUrl: string;
        official: boolean;
        serverData: IServerData;
    };
    abstract get(endpoint: string, params?: any): angular.IPromise<any>;
    abstract post(endpoint: string, params?: any): angular.IPromise<any>;
}

export function ApiServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('Api');
}

export const ApiServiceProvider = {
    provide: ApiService,
    useFactory: ApiServiceFactory,
    deps: ['$injector']
};